import React, { useCallback, useRef, useState } from "react";
import styled from "styled-components";
import { Asset, Flex } from "@thenounproject/lingo-core";

import ColorDisplay from "./elements/ColorDisplay";
import useResizeObserver from "@components/hooks/useResizeObserver";

const ColorContainer = styled(Flex).attrs({
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
})``;

type Props = {
  asset: Asset;
  lazy?: boolean;
};

function AssetPreviewColor({ asset }: Props) {
  const [smallMode, setSmallMode] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleResize = useCallback((node: Element) => {
    setSmallMode(node.clientWidth < 100);
  }, []);
  useResizeObserver(wrapperRef, handleResize);

  return (
    <ColorContainer ref={wrapperRef}>
      <ColorDisplay asset={asset} smallMode={smallMode} />
    </ColorContainer>
  );
}

export default React.memo(AssetPreviewColor);
